import React, { useRef } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa"; // Importing arrow icons
import { getImageUrl } from "../../../../Utils/localStorageUtils";

const photos = [
  "https://img.staticmb.com/mbimages/project/Photo_h310_w462/2024/07/12/Project-Photo-37-Manglam-Aananda-Jaipur-5020643_900_1600_310_462.jpg", // Replace with actual image
  "https://img.staticmb.com/mbimages/project/Photo_h310_w462/2024/07/12/Project-Photo-36-Manglam-Aananda-Jaipur-5020643_900_1600_310_462.jpg", // Replace with actual image
  "https://img.staticmb.com/mbimages/project/Photo_h310_w462/2024/07/12/Project-Photo-36-Manglam-Aananda-Jaipur-5020643_900_1600_310_462.jpg", // Replace with actual image
  "https://img.staticmb.com/mbimages/project/Photo_h310_w462/2024/07/12/Project-Photo-36-Manglam-Aananda-Jaipur-5020643_900_1600_310_462.jpg", // Replace with actual image
  "https://img.staticmb.com/mbimages/project/Photo_h310_w462/2024/07/12/Project-Photo-36-Manglam-Aananda-Jaipur-5020643_900_1600_310_462.jpg", // Replace with actual image
];

const PhotoGallerySection = ({project}) => {

  const imageContainerRef = useRef(null);
  const images = project?.media?.projectPictures || [];

  if (!images.length) return null; // Don't render if no images

  const scrollGallery = (direction) => {
    if (imageContainerRef.current) {
      const scrollAmount = 250;
      imageContainerRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };


  return (
    <div className="max-w-5xl mx-auto p-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold">Videos & Photos of Manglam Aananda</h2>
        <div className="flex space-x-2">
          <button onClick={() => scrollGallery("left")} className="p-2 bg-gray-200 rounded-full hover:bg-gray-300">
            <FaArrowLeft size={18} />
          </button>
          <button onClick={() => scrollGallery("right")} className="p-2 bg-gray-200 rounded-full hover:bg-gray-300">
            <FaArrowRight size={18} />
          </button>
        </div>
      </div>

      {/* Image Gallery */}
      <div ref={imageContainerRef} className="flex space-x-4 overflow-x-auto scrollbar-hide" >
        {images.map((photo, index) => (
          <div key={index} className="w-60 flex-shrink-0">
            <img
              src={getImageUrl(photo)}
              onError={(e)=>e.target.src="https://img.staticmb.com/mbimages/project/Photo_h310_w462/2024/07/12/Project-Photo-37-Manglam-Aananda-Jaipur-5020643_900_1600_310_462.jpg"}
              alt={`Gallery ${index + 1}`}
              className="w-full h-40 object-cover rounded-lg shadow-md"
            />
          </div>
        ))}
      </div>

      {/* See All Link */}
      <div className="mt-3">
        <a href="#" className="text-red-600 font-medium hover:underline">
          See all Photos / Videos
        </a>
      </div>
    </div>
  );
};

export default PhotoGallerySection;
